/* src/app/common/ai-input/ai-input.component.scss */
.input-container {
  position: relative;
}
.editable-input {
  min-height: 100px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  min-width: 500px;
  overflow: auto;
  background: white;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.5;
  white-space: pre-wrap;
  max-width: 500px;
}
.editable-input:focus {
  outline: none;
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.dropdown {
  border: 1px solid #ccc;
  padding-top: 8px;
  border-radius: 8px;
  min-height: 300px;
  max-height: 300px;
  max-width: 500px;
  overflow-y: auto;
  overflow-x: auto;
}
.dropdown ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dropdown li {
  padding: 2px;
  margin: 2px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}
.dropdown li:hover {
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}
.shimmer {
  animation: shimmer 2s infinite linear;
  background: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
  background-size: 1000px 100%;
  position: relative;
  overflow: hidden;
}
.shimmer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: inherit;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left {
  flex: 1;
}
.right {
  display: flex;
  align-items: center;
}
.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}
button {
  flex: 1 1 calc(40% - 10px);
  margin-top: 16px;
  margin: 8px;
  padding: 8px;
  border: 1px solid black;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  text-align: center;
}
button:hover {
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.dropdown ul {
  list-style-type: none;
}
::ng-deep .ant-tabs-tab {
  padding: 5px 8px !important;
}
::ng-deep .ant-tabs-tab-btn {
  font-size: 12px !important;
}
::ng-deep .ant-tabs-ink-bar {
  background-color: black !important;
}
.selected {
  color: #187C82;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vYWktaW5wdXQvYWktaW5wdXQuY29tcG9uZW50LnNjc3MiXSwKICAic291cmNlc0NvbnRlbnQiOiBbIlxuLmlucHV0LWNvbnRhaW5lciB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuLmVkaXRhYmxlLWlucHV0IHtcbiAgbWluLWhlaWdodDogMTAwcHg7XG4gIHBhZGRpbmc6IDhweDtcbiAgYm9yZGVyOiAxcHggc29saWQgI2Q5ZDlkOTtcbiAgYm9yZGVyLXJhZGl1czogOHB4O1xuICBtaW4td2lkdGg6IDUwMHB4O1xuICBvdmVyZmxvdzogYXV0bztcbiAgYmFja2dyb3VuZDogd2hpdGU7XG4gIGZvbnQtZmFtaWx5OiBpbmhlcml0O1xuICBmb250LXNpemU6IGluaGVyaXQ7XG4gIGxpbmUtaGVpZ2h0OiAxLjU7XG4gIHdoaXRlLXNwYWNlOiBwcmUtd3JhcDtcbiAgbWF4LXdpZHRoOiA1MDBweDtcbn1cblxuLmVkaXRhYmxlLWlucHV0OmZvY3VzIHtcbiAgb3V0bGluZTogbm9uZTtcbiAgYm9yZGVyLWNvbG9yOiAjNDBhOWZmO1xuICBib3gtc2hhZG93OiAwIDAgMCAycHggcmdiYSgyNCwgMTQ0LCAyNTUsIDAuMik7XG59XG5cbi5kcm9wZG93biB7XG4gIGJvcmRlcjogMXB4IHNvbGlkICNjY2M7XG4gIHBhZGRpbmctdG9wOiA4cHg7XG4gIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgbWluLWhlaWdodDogMzAwcHg7XG4gIG1heC1oZWlnaHQ6IDMwMHB4O1xuICBtYXgtd2lkdGg6IDUwMHB4O1xuICBvdmVyZmxvdy15OiBhdXRvOyAvLyBFbmFibGUgdmVydGljYWwgc2Nyb2xsaW5nXG4gIG92ZXJmbG93LXg6IGF1dG87IC8vIEVuYWJsZSBob3Jpem9udGFsIHNjcm9sbGluZ1xufVxuXG4uZHJvcGRvd24gdWwge1xuICBsaXN0LXN0eWxlLXR5cGU6IG5vbmU7XG4gIHBhZGRpbmc6IDA7XG4gIG1hcmdpbjogMDtcbn1cblxuLmRyb3Bkb3duIGxpIHtcbiAgcGFkZGluZzogMnB4OyAvLyBJbmNyZWFzZWQgcGFkZGluZyBmb3IgY2FyZC1saWtlIGFwcGVhcmFuY2VcbiAgbWFyZ2luOiAycHg7IC8vIE1hcmdpbiBiZXR3ZWVuIGNhcmRzXG4gIGJvcmRlcjogMXB4IHNvbGlkICNkZGQ7IC8vIEJvcmRlciBmb3IgY2FyZFxuICBib3JkZXItcmFkaXVzOiA4cHg7IC8vIFJvdW5kZWQgY29ybmVyc1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmOyAvLyBXaGl0ZSBiYWNrZ3JvdW5kIGZvciBjYXJkXG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAwLjNzLCBib3gtc2hhZG93IDAuM3M7IC8vIFNtb290aCB0cmFuc2l0aW9uIGZvciBob3ZlciBlZmZlY3RzXG59XG5cbi5kcm9wZG93biBsaTpob3ZlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmOWY5Zjk7IC8vIFNsaWdodGx5IGRhcmtlciBiYWNrZ3JvdW5kIG9uIGhvdmVyXG4gIGJveC1zaGFkb3c6IDAgNHB4IDhweCByZ2JhKDAsIDAsIDAsIDAuMTUpOyAvLyBTbGlnaHRseSBsYXJnZXIgc2hhZG93IG9uIGhvdmVyXG59XG5cbkBrZXlmcmFtZXMgc2hpbW1lciB7XG4gIDAlIHtcbiAgICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiAtMTAwMHB4IDA7XG4gIH1cbiAgMTAwJSB7XG4gICAgYmFja2dyb3VuZC1wb3NpdGlvbjogMTAwMHB4IDA7XG4gIH1cbn1cblxuLnNoaW1tZXIge1xuICBhbmltYXRpb246IHNoaW1tZXIgMnMgaW5maW5pdGUgbGluZWFyO1xuICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsICNmNmY3ZjggMCUsICNlZGVlZjEgMjAlLCAjZjZmN2Y4IDQwJSwgI2Y2ZjdmOCAxMDAlKTtcbiAgYmFja2dyb3VuZC1zaXplOiAxMDAwcHggMTAwJTtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBvdmVyZmxvdzogaGlkZGVuO1xufVxuXG4uc2hpbW1lcjo6YmVmb3JlIHtcbiAgY29udGVudDogJyc7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBiYWNrZ3JvdW5kOiBpbmhlcml0O1xufVxuXG4uY29udGFpbmVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4ubGVmdCB7XG4gIGZsZXg6IDE7XG59XG5cbi5yaWdodCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG59XG5cbi5idXR0b24tY29udGFpbmVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiB3cmFwOyAvKiBBbGxvdyBidXR0b25zIHRvIHdyYXAgdG8gdGhlIG5leHQgcm93ICovXG4gIGdhcDogMTBweDsgLyogQWRqdXN0IHRoZSBnYXAgYmV0d2VlbiBidXR0b25zIGFzIG5lZWRlZCAqL1xuICB3aWR0aDogMTAwJTsgLyogRW5zdXJlIHRoZSBjb250YWluZXIgdGFrZXMgdXAgdGhlIGZ1bGwgd2lkdGggKi9cbn1cblxuYnV0dG9uIHtcbiAgZmxleDogMSAxIGNhbGMoNDAlIC0gMTBweCk7IC8qIEFsbG93IGJ1dHRvbnMgdG8gZ3JvdyBhbmQgZmlsbCBhdmFpbGFibGUgc3BhY2UsIHdpdGggYSBtYXggb2YgMiBwZXIgcm93ICovXG4gIG1hcmdpbi10b3A6IDE2cHg7XG4gIG1hcmdpbjogOHB4O1xuICBwYWRkaW5nOiA4cHg7XG4gIGJvcmRlcjogMXB4IHNvbGlkIGJsYWNrOyAvKiBCb3JkZXIgZm9yIGNhcmQgKi9cbiAgYm9yZGVyLXJhZGl1czogOHB4OyAvKiBSb3VuZGVkIGNvcm5lcnMgKi9cbiAgYm94LXNoYWRvdzogMCAycHggNHB4IHJnYmEoMCwgMCwgMCwgMC4xKTsgLyogU3VidGxlIHNoYWRvdyBmb3IgY2FyZCBlZmZlY3QgKi9cbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjsgLyogV2hpdGUgYmFja2dyb3VuZCBmb3IgY2FyZCAqL1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIHRyYW5zaXRpb246IGJhY2tncm91bmQtY29sb3IgMC4zcywgYm94LXNoYWRvdyAwLjNzOyAvKiBTbW9vdGggdHJhbnNpdGlvbiBmb3IgaG92ZXIgZWZmZWN0cyAqL1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7IC8qIENlbnRlciB0ZXh0IGluc2lkZSB0aGUgYnV0dG9uICovXG59XG5cblxuYnV0dG9uOmhvdmVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2Y5ZjlmOTsgLyogU2xpZ2h0bHkgZGFya2VyIGJhY2tncm91bmQgb24gaG92ZXIgKi9cbiAgYm94LXNoYWRvdzogMCA0cHggOHB4IHJnYmEoMCwgMCwgMCwgMC4xNSk7IC8qIFNsaWdodGx5IGxhcmdlciBzaGFkb3cgb24gaG92ZXIgKi9cbn1cblxuLmRyb3Bkb3duIHVsIHtcbiAgbGlzdC1zdHlsZS10eXBlOiBub25lO1xufVxuXG46Om5nLWRlZXAgLmFudC10YWJzLXRhYiB7XG4gIHBhZGRpbmc6IDVweCA4cHggIWltcG9ydGFudDsgLy8gQWRqdXN0IHBhZGRpbmcgdG8gbWFrZSB0aGUgaGVpZ2h0IHNtYWxsZXJcbn1cblxuOjpuZy1kZWVwIC5hbnQtdGFicy10YWItYnRuIHtcbiAgZm9udC1zaXplOiAxMnB4ICFpbXBvcnRhbnQ7IC8vIEFkanVzdCBmb250IHNpemUgaWYgbmVlZGVkXG59XG5cbjo6bmctZGVlcCAuYW50LXRhYnMtaW5rLWJhciB7XG4gIGJhY2tncm91bmQtY29sb3I6IGJsYWNrICFpbXBvcnRhbnQ7IC8vIENoYW5nZSB1bmRlcmxpbmUgY29sb3IgdG8gYmxhY2tcbn1cblxuLnNlbGVjdGVkIHtcbiAgY29sb3I6ICMxODdDODI7IC8qIG9yIGFueSBjb2xvciB5b3UgcHJlZmVyICovXG59Il0sCiAgIm1hcHBpbmdzIjogIjtBQUNBLENBQUE7QUFDRSxZQUFBOztBQUdGLENBQUE7QUFDRSxjQUFBO0FBQ0EsV0FBQTtBQUNBLFVBQUEsSUFBQSxNQUFBO0FBQ0EsaUJBQUE7QUFDQSxhQUFBO0FBQ0EsWUFBQTtBQUNBLGNBQUE7QUFDQSxlQUFBO0FBQ0EsYUFBQTtBQUNBLGVBQUE7QUFDQSxlQUFBO0FBQ0EsYUFBQTs7QUFHRixDQWZBLGNBZUE7QUFDRSxXQUFBO0FBQ0EsZ0JBQUE7QUFDQSxjQUFBLEVBQUEsRUFBQSxFQUFBLElBQUEsS0FBQSxFQUFBLEVBQUEsR0FBQSxFQUFBLEdBQUEsRUFBQTs7QUFHRixDQUFBO0FBQ0UsVUFBQSxJQUFBLE1BQUE7QUFDQSxlQUFBO0FBQ0EsaUJBQUE7QUFDQSxjQUFBO0FBQ0EsY0FBQTtBQUNBLGFBQUE7QUFDQSxjQUFBO0FBQ0EsY0FBQTs7QUFHRixDQVhBLFNBV0E7QUFDRSxtQkFBQTtBQUNBLFdBQUE7QUFDQSxVQUFBOztBQUdGLENBakJBLFNBaUJBO0FBQ0UsV0FBQTtBQUNBLFVBQUE7QUFDQSxVQUFBLElBQUEsTUFBQTtBQUNBLGlCQUFBO0FBQ0Esb0JBQUE7QUFDQSxVQUFBO0FBQ0EsY0FBQSxpQkFBQSxJQUFBLEVBQUEsV0FBQTs7QUFHRixDQTNCQSxTQTJCQSxFQUFBO0FBQ0Usb0JBQUE7QUFDQSxjQUFBLEVBQUEsSUFBQSxJQUFBLEtBQUEsQ0FBQSxFQUFBLENBQUEsRUFBQSxDQUFBLEVBQUE7O0FBR0YsV0FBQTtBQUNFO0FBQ0UseUJBQUEsUUFBQTs7QUFFRjtBQUNFLHlCQUFBLE9BQUE7OztBQUlKLENBVEE7QUFVRSxhQUFBLFFBQUEsR0FBQSxTQUFBO0FBQ0EsY0FBQSxnQkFBQSxHQUFBLEtBQUEsRUFBQSxRQUFBLEVBQUEsRUFBQSxRQUFBLEdBQUEsRUFBQSxRQUFBLEdBQUEsRUFBQSxRQUFBO0FBQ0EsbUJBQUEsT0FBQTtBQUNBLFlBQUE7QUFDQSxZQUFBOztBQUdGLENBakJBLE9BaUJBO0FBQ0UsV0FBQTtBQUNBLFlBQUE7QUFDQSxPQUFBO0FBQ0EsUUFBQTtBQUNBLFNBQUE7QUFDQSxVQUFBO0FBQ0EsY0FBQTs7QUFHRixDQUFBO0FBQ0UsV0FBQTtBQUNBLG1CQUFBO0FBQ0EsZUFBQTs7QUFHRixDQUFBO0FBQ0UsUUFBQTs7QUFHRixDQUFBO0FBQ0UsV0FBQTtBQUNBLGVBQUE7O0FBR0YsQ0FBQTtBQUNFLFdBQUE7QUFDQSxhQUFBO0FBQ0EsT0FBQTtBQUNBLFNBQUE7O0FBR0Y7QUFDRSxRQUFBLEVBQUEsRUFBQSxLQUFBLElBQUEsRUFBQTtBQUNBLGNBQUE7QUFDQSxVQUFBO0FBQ0EsV0FBQTtBQUNBLFVBQUEsSUFBQSxNQUFBO0FBQ0EsaUJBQUE7QUFDQSxjQUFBLEVBQUEsSUFBQSxJQUFBLEtBQUEsQ0FBQSxFQUFBLENBQUEsRUFBQSxDQUFBLEVBQUE7QUFDQSxvQkFBQTtBQUNBLFVBQUE7QUFDQSxjQUFBLGlCQUFBLElBQUEsRUFBQSxXQUFBO0FBQ0EsY0FBQTs7QUFJRixNQUFBO0FBQ0Usb0JBQUE7QUFDQSxjQUFBLEVBQUEsSUFBQSxJQUFBLEtBQUEsQ0FBQSxFQUFBLENBQUEsRUFBQSxDQUFBLEVBQUE7O0FBR0YsQ0FyR0EsU0FxR0E7QUFDRSxtQkFBQTs7QUFHRixVQUFBLENBQUE7QUFDRSxXQUFBLElBQUE7O0FBR0YsVUFBQSxDQUFBO0FBQ0UsYUFBQTs7QUFHRixVQUFBLENBQUE7QUFDRSxvQkFBQTs7QUFHRixDQUFBO0FBQ0UsU0FBQTs7IiwKICAibmFtZXMiOiBbXQp9Cg== */
